import { createContext } from "react";

const dbmContext = createContext();
export default dbmContext;